import { Link } from 'react-router-dom';
import { seoArticle } from '@/mocks/homeData';

export default function SEOSection() {
  return (
    <section id="guide" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden h-[400px] md:h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=Thoughtfully%20arranged%20creative%20workspace%20scene%20with%20an%20open%20journal%20filled%20with%20handwritten%20notes%20and%20diagrams%20beside%20a%20laptop%20showing%20a%20colorful%20spreadsheet%20a%20ceramic%20vase%20with%20dried%20pampas%20grass%20and%20a%20half%20full%20glass%20of%20water%20on%20a%20warm%20walnut%20desk%20surface%20afternoon%20sunlight%20streaming%20through%20sheer%20linen%20curtains&width=1200&height=1600&seq=seo-hub-2026-v4&orientation=portrait"
                alt="Superbuy Sheet research methodology with fashion items"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute top-4 left-4 flex gap-2 flex-wrap">
                <span className="px-3 py-1.5 rounded-lg bg-background-50/70 backdrop-blur-sm text-foreground-800 text-xs font-label whitespace-nowrap">SEO Optimized</span>
                <span className="px-3 py-1.5 rounded-lg bg-background-50/70 backdrop-blur-sm text-foreground-800 text-xs font-label whitespace-nowrap">Weekly Updated</span>
                <span className="px-3 py-1.5 rounded-lg bg-background-50/70 backdrop-blur-sm text-foreground-800 text-xs font-label whitespace-nowrap">Western Fashion</span>
              </div>
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col justify-center">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-5">
              Superbuy Sheet Research Hub
            </h2>
            <div className="flex flex-wrap gap-2 mb-6">
              <span className="px-4 py-1.5 rounded-full border border-foreground-300 text-foreground-700 text-xs font-label whitespace-nowrap">
                Beginner Guide
              </span>
              <span className="px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-label whitespace-nowrap">
                Advanced Tips
              </span>
              <span className="px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-label whitespace-nowrap">
                Category Breakdown
              </span>
              <span className="px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-label whitespace-nowrap">
                Tools
              </span>
            </div>

            <div className="bg-foreground-950 rounded-2xl p-8 md:p-10">
              <div className="flex flex-col md:flex-row gap-6">
                <div className="flex-1">
                  <h3 className="text-background-50 text-lg md:text-xl font-label font-semibold mb-4 leading-snug">
                    Why Superbuy Sheet Eliminates Hours of Product Hunting
                  </h3>
                  <p className="text-background-300 text-sm leading-relaxed mb-6">
                    Most shoppers waste 6-8 hours per haul on disorganized research. The Superbuy Sheet methodology transforms this chaos into a streamlined, data-driven process that cuts research time by over 60% while improving purchase quality. Track prices, compare QC photos, and make confident decisions — all from one centralized spreadsheet system.
                  </p>
                  <Link
                    to={`/${seoArticle.slug}`}
                    className="inline-flex items-center gap-2 text-background-50 text-sm font-label font-medium whitespace-nowrap cursor-pointer hover:text-accent-300 transition-colors"
                  >
                    Read SEO Article
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
                <div className="hidden md:block w-[35%] flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Clean%20top%20down%20view%20of%20color%20coded%20sticky%20notes%20and%20highlighters%20arranged%20around%20a%20tablet%20device%20displaying%20an%20organized%20product%20comparison%20grid%20on%20a%20crisp%20white%20desk%20surface%20with%20a%20warm%20terracotta%20colored%20notebook%20at%20the%20corner%20soft%20even%20studio%20lighting&width=400&height=400&seq=seo-card-thumb-2026-v4&orientation=squarish"
                    alt="Superbuy Sheet organized research"
                    className="w-full aspect-square object-cover rounded-xl"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}